import { put, select, takeLatest } from 'redux-saga/effects'
import { getPnProcedureSelector } from '../selectors/pnProcedure.selector'
import { IPnProcedureState } from '../store/pnProcedure.types'
import { PnProcedureConstants } from '../store/pnProcedure.constants'
import { savePnProcedure, setPnProcList } from '../store/pnProcedure.actions'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { cloneDeep } from 'lodash'

export function* setPertinentNegativeProcedureMetadata() {
  const pnProcedureState: IPnProcedureState = yield select(getPnProcedureSelector)
  const { pnProcedure, procedurePNNVs } = pnProcedureState
  const existingIndex = procedurePNNVs?.findIndex((proc) => proc?.id === pnProcedure?.id)
  const copiedPertNegPros = cloneDeep(procedurePNNVs)

  try {
    if (existingIndex !== -1) {
      if (pnProcedure?.nemsisCodePNNV) {
        copiedPertNegPros[existingIndex] = {
          ...copiedPertNegPros[existingIndex],
          nemsisCodePNNV: pnProcedure.nemsisCodePNNV,
          nemsisCode: pnProcedure.nemsisCode,
        }
        yield put(setPnProcList(copiedPertNegPros))
      } else {
        const filteredCategoryList = copiedPertNegPros.filter((item) => item.id !== pnProcedure?.id)
        yield put(setPnProcList(filteredCategoryList))
      }
    } else {
      yield put(setPnProcList([...procedurePNNVs, pnProcedure]))
    }
    yield put(savePnProcedure())
  } catch (e) {
    yield put(throwPcrException(`setPertinentNegativeProcedureMetadata() error: ${e}`))
  }
}

export function* setPertinentNegativeProcedureMetadataSaga() {
  yield takeLatest([PnProcedureConstants.SET_PN_PROCEDURE], performWithMutexHOG, setPertinentNegativeProcedureMetadata)
}
